module.exports = __webpack_public_path__ + "img/btn_menu-close.96c89000.png";